<template>
  <div class="header-container">
    <div class="header-container_main">
      <div class="school-logo">
        <div class="logo"></div>
        <div class="head_title">四川大学高等教育自学考试-校外教学点申请系统</div>
      </div>
      <div v-throttle class="login_out_button" @click="quitLogin">
        <img src="@/assets/main/login_out.png" alt="">
        <span>退出</span>
      </div>

    </div>
  </div>
</template>
  
<script>
export default {
  name: 'PageHead',
  data() {
    return {
      showUserName: false
    }
  },
  computed: {
    userName() {
      return this.$store.state.userName
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    quit() { // 退出到登录页
      this.$store.commit('userExit')
    },
    quitLogin() {
      this.$store.commit('removeUser')
      this.$router.replace({ path: '/' })
    }
  }
}
</script>
  
<style scoped lang="less">
.header-container {
  padding: 0;
  box-sizing: border-box;
  background-color: #ba2a17;
.header-container_main{
  max-width: 1474px;
  box-sizing: border-box;
  padding: 0 20px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
  .school-logo {
    width: 1080px;
    margin-left: 0;
    display: flex;
    height: 100px;

    align-items: center;

    .logo {
      height: 87px;
      width: 370px;
      background: url("../assets/home/logo.png") no-repeat 0 0;
      background-size: 100% 100%;
    }

    .head_title {
      font-size: 28px;
      line-height: 1;
      color: white;
      margin-left: 58px;
    }
  }

  .school-name {
    margin-left: 6vw;
    line-height: 100px;
    color: white;
    letter-spacing: 3px;
  }

  .user-handle {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: white;

    .exit {
      margin-left: 30px;
    }
  }
  .login_out_button {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-left: 15px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }

      span {
        font-size: 16px;
        color: white;
        line-height: 1;
      }
    }
}

@media screen and (max-width: 1366px) {
  .school-logo {
    margin-left: 0px !important;
    width: 1030px !important;
  }

  .school-name {
    margin-left: 4vw !important;
  }
  .head_title{
    margin-left: 40px !important;
  }
  .header-container_main{
    justify-content: space-around !important;
  }

  .user-handle {
    .exit {
      margin-left: 20px !important;
    }
  }
}
</style>
  